









































import {Vue, Component} from 'vue-property-decorator';
import {addClass, removeClass} from '@/utils/classUtils';
import {GetOrderProductsRequest} from 'supporter';
@Component
export default class Benefit extends Vue {
  private accumulationList: any[] = [];
  private totalAccumulation: any = 0;

  private isLast: boolean = false;
  private created(): void {}
  private mounted(): void {
    addClass(document.body, 'popup popup_small');
    this.getOrderProductInfo();
  }
  private beforeDestroy(): void {
    removeClass(document.body, 'popup popup_small');
  }
  private getOrderProductInfo(): void {
    let ProductInfoRequest: GetOrderProductsRequest = {
      params: {
        orderNo: this.$route.query.orderNo as any
      }
    };
    this.$api.getOrderProducts(ProductInfoRequest).then((res): any => {
      this.getAccululationList(res.data);
    });
  }
  private getAccululationList(arr: any): void {
    this.accumulationList = [];
    if (arr.length === 0) {
      return;
    }
    arr.map((item: any): any => {
      item.orderOptions.map((opItem: any): any => {
        if(opItem.possibleToGetAccumulationAmt === true) {
          this.accumulationList.push({
            name: opItem.productName,
            optionName: this.getProductOption(opItem.optionName, opItem.optionValue),
            usesOption: opItem.usesOption,
            accumulationAmt: opItem.accumulationAmt.toLocaleString()
          });
          this.totalAccumulation += Number(opItem.accumulationAmt);
        }
      });
    });
    this.totalAccumulation = this.totalAccumulation.toLocaleString();
  }

  private getProductOption(name, value) {
    let optionName = name.split('|');
    let optionValue = value.split('|');
    let optionFullName = []

    for(let i=0; i<optionName.length; i++) {
      optionFullName[i] = optionName[i] + ':' + optionValue[i];
    }
    return optionFullName.join(' | ')
  }
}
